// ============================================================
// sidebar.js — Comportamiento del sidebar + modal de ayuda
// ============================================================
import { qs, qsa, on } from './utils.js';
import { toast } from './toast.js';
import { translations } from './translations.js';
import { setAppLanguage } from './i18n.js';
import { getUser } from './api.js';

const COLLAPSED_KEY = 'vimo:sidebar-collapsed';

export function initSidebar() {
  const sidebar = qs('#appSidebar');
  const backdrop = qs('#sidebarBackdrop');
  if (!sidebar) return;

  const openBtn = qs('[data-action="open-sidebar"]');
  const toggleBtn = qs('[data-action="toggle-sidebar"]');

  // Restaurar estado colapsado guardado (solo aplica en escritorio)
  if (localStorage.getItem(COLLAPSED_KEY) === '1') {
    sidebar.classList.add('is-collapsed');
  }

  const openSidebar = () => {
    sidebar.classList.add('is-open');
    backdrop?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  };

  const closeSidebar = () => {
    sidebar.classList.remove('is-open');
    backdrop?.classList.remove('is-visible');
    document.body.style.overflow = '';
  };

  openBtn?.addEventListener('click', openSidebar);
  backdrop?.addEventListener('click', closeSidebar);
  toggleBtn?.addEventListener('click', () => {
    // En móvil/tablet: cierra el panel desplegable.
    // En escritorio: colapsa/expande y guarda el estado.
    if (window.matchMedia('(max-width: 992px)').matches) {
      closeSidebar();
    } else {
      sidebar.classList.toggle('is-collapsed');
      localStorage.setItem(
        COLLAPSED_KEY,
        sidebar.classList.contains('is-collapsed') ? '1' : '0'
      );
    }
  });

  // Cierra al pulsar Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSidebar();
  });

  // Marca el enlace activo según la página
  const page = document.body.dataset.page;
  if (page) {
    qsa(`.sidebar-link[data-nav="${page}"]`).forEach((a) => a.classList.add('active'));
  }

  // Cierra el sidebar móvil cuando se hace clic en un enlace
  on(sidebar, 'click', '.sidebar-link', () => {
    if (window.matchMedia('(max-width: 992px)').matches) closeSidebar();
  });

  // ── Modal de ayuda ──────────────────────────────────────────
  const helpModal = qs('#helpModal');
  if (!helpModal) return;

  const openHelp  = () => { 
    helpModal.hidden = false; 
    const user = getUser();
    if (user) {
      const nombreInput = qs('#helpNombre');
      const emailInput = qs('#helpEmail');
      if (nombreInput && !nombreInput.value) nombreInput.value = user.name || '';
      if (emailInput && !emailInput.value) emailInput.value = user.email || '';
    }
    const msgInput = qs('#helpMsg');
    if (msgInput) msgInput.focus();
    else helpModal.querySelector('input')?.focus(); 
  };
  const closeHelp = () => { helpModal.hidden = true; };

  on(document, 'click', '[data-action="open-help"]',  openHelp);
  on(document, 'click', '[data-action="close-help"]', closeHelp);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !helpModal.hidden) closeHelp();
  });

  qs('[data-help-form]')?.addEventListener('submit', (e) => {
    e.preventDefault();
    const fd      = new FormData(e.target);
    const payload = Object.fromEntries(fd.entries());
    console.log('[Vimo] help form', payload);
    // TODO backend: POST /api/support { nombre, email, mensaje }
    closeHelp();
    e.target.reset();
    toast({ message: '¡Mensaje enviado! Te responderemos en breve.', type: 'success' });
  });

  // Redirige a precios cuando el usuario pulsa "Actualizar a Premium" o el banner
  on(document, 'click', '[data-action="upgrade"]', () => {
    window.location.href = 'precios.html';
  });

  // ── Selector de Idioma (delegado al gestor centralizado i18n) ──
  const langSelector = qs('.lang-selector');
  if (langSelector) {
    const options = qsa('.lang-option');
    options.forEach(opt => {
      opt.addEventListener('click', () => {
        const lang = opt.dataset.lang;
        setAppLanguage(lang);
        langSelector.classList.remove('is-open');

        const langNames = { es: 'Español', en: 'English', pt: 'Português' };
        const toastMsgs = {
          es: `Idioma cambiado a ${langNames[lang]}`,
          en: `Language changed to ${langNames[lang]}`,
          pt: `Idioma alterado para ${langNames[lang]}`
        };
        toast({ message: toastMsgs[lang] || toastMsgs.es, type: 'success' });
      });
    });
  }
}
